import { getShopAuthority } from './shopAuthorityRepo';

import { addDoc, collection, doc, documentId, getDocs, getFirestore, query, setDoc, updateDoc, where } from 'firebase/firestore';
import Shop, { SHOP, shopConverter } from '../entities/Shop';
import firebase from '../firebase/Firebase';
import { sliceByNumber } from '../lib/array';


const store = getFirestore(firebase);

export const getShop = async (id: string, agentId: string) => {
  return getShopAuthority(id, agentId).then((authority) => {

    if (!authority) return null

    const ref = collection(store, SHOP).withConverter(shopConverter);
    const q = query(ref,
      where(documentId(), '==', id)
    )
    return getDocs(q).then((snap) => {
      return snap.docs.map((doc) => {
        return doc.data();
      })
    }).then((shops) => shops?.[0] || null)

  })
};

export const getShopWhereHashIs = async (hash: string) => {
  const ref = collection(store, SHOP).withConverter(shopConverter);
  const q = query(ref, where('hash', '==', hash))
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data()
    });
  });
}

export const getShopWhereWebToTicketHashIs = async (hash: string) => {
  const ref = collection(store, SHOP).withConverter(shopConverter);
  const q = query(ref, where('webToTicketHash', '==', hash))
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data()
    });
  });
}

export const getShopsByIds = async (ids: string[]) => {

  const ref = collection(store, SHOP).withConverter(shopConverter);
  const sliced = sliceByNumber(ids, 10)
  const promises = sliced.map((ids) => {
    const q = query(ref, where(documentId(), 'in', ids))
    return getDocs(q).then((snap) => snap.docs.map((doc) => doc.data()));
  })
  return await Promise.all(promises).then((results) => results.flat())
}

export const getShopsBySubDomain = async (name: string) => {
  const ref = collection(store, SHOP).withConverter(shopConverter);
  const q = query(ref, where('subdomain', '==', name))
  return await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    });
  });
}

// security rule的に使えない
// export const getShopsByName = async (subdomain: string) => {
//   const ref = collection(store, SHOP).withConverter(shopConverter);
//   const q = query(ref, where('name', '==', subdomain))
//   return await getDocs(q).then((snap) => {
//     return snap.docs.map((doc) => {
//       return doc.data();
//     });
//   }).catch((error) => {
//     console.warn(error);
//     return null;
//   });
// }

export const addShop = async (shop: Shop) => {
  return await addDoc(collection(store, SHOP).withConverter(shopConverter), shop)
    .then((ref) => {
      return ref.id;
    })
};

export const setShop = async (shop: Shop) => {
  const ref = doc(store, SHOP, shop.id).withConverter(shopConverter);
  await setDoc(ref, shop).catch((error) => {
    console.warn(error);
  });
};

export const updateShop = async (shop: Shop) => {
  const ref = doc(store, SHOP, shop.id).withConverter(shopConverter);
  return await updateDoc(ref, shop)
};